import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { Icon20 } from 'builder/components/Icon'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  width: 480px;
  height: auto;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  z-index: 3;
  background-color: ${Colors.White};
  padding: ${Spacing.L};
  gap: ${Spacing.L};
  position: relative;

  ${Media.Phone`
    width: 343px;
  `};
`

export const ActionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: ${Spacing['2XS']};
`

export const CloseIconWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  top: 48px;
  right: 48px;

  ${Media.Phone`
    top: 5px;
    right: 5px;
  `}
`

export const CloseIcon = styled(Icon20.Close)`
  color: ${Colors.Neutral50};
  position: absolute;
  border-radius: 28px;
  width: 28px;
  height: 28px;
  padding: 4px;
  background: ${Colors.Neutral10};

  &:hover {
    background: ${Colors.Blue10};
    color: ${Colors.Blue50};
  }

  ${Media.Phone`
    width: 24px;
    height: 24px;
    padding: 2px;
    top: 20px;
    right: 20px;
  `};
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${Spacing.XS};
`

export const Title = styled.p`
  ${Typography.S};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral90};
`

export const Description = styled.p`
  ${Typography.Body};
  color: ${Colors.Neutral50};
`
